import axios from "axios";

export default axios.create({
  baseURL: "https://api.maitriai.com:8002/api/",
  // baseURL: "https://34.197.250.249:8002/api",
  headers: {
    "Content-Type": "application/json",
  },
});

//  https://api.maitriai.com:8002/api
//  https://ec2-34-197-250-249.compute-1.amazonaws.com:8002
//  https://ec2-34-197-250-249.compute-1.amazonaws.com:8002/api
